import request from '@/utils/request'

export const getTask = () => request.get('/workflow-api/credit-task/count')

export const getWorkList = () =>
  request.get('/workflow-api/task-delegate/delegate/query')

// 获取 work delegation to
export const getDelegateList = () =>
  request.get('/workflow-api/task-delegate/agent/list')

// 新增委托人
export const addDelegate = params =>
  request.post('/workflow-api/task-delegate/delegate', params)

// 个人中心-watch list
export const getWatchList = params =>
  request.post('/customer-api/watch-list/home/page', params)

// Total Ar 图表
export const getTotalAr = params => request.post('/customer-api/ar/sum', params)

// total credit trend
export const getTotalTrend = params =>
  request.post('/customer-api/credit-trend/statistics_all', params)

// 获取客户信息
export const getCusInfo = id =>
  request.get(`/customer-api/customer/query/${id}`)
// 新增用户查看客户日志
export const getAddlog = params =>
  request.post('/customer-api/company-search-logs/add', params)
// 最近查看5家企业
export const getRecently = params =>
  request.get('/customer-api/company-search-logs/list', params)

// 获取 Total Credit Trend GEO 列表 和 Region 列表
export const getTotalSearchList = params =>
  request.post('/masterdata-api/valuelist/getValueList', params)

export const getStockList = params =>
  request.post('/customer-api/customer/ai/stockList', params)

export const getNewsList = params =>
  request.post('/customer-api/customer/ai/newsList', params)

export const getNewDetailList = params =>
  request.post('/customer-api/customer/ai/newsDetailList', params)
export const getWatchStockNewsListData = params =>
  request.post('/customer-api/customer/ai/getWatchStockNewsListData', params)
export const deleteWatchStockNewsItem = params =>
  request.post('/customer-api/customer/ai/removeFromWatchStockNewsList', params)
export const addWatchStockNews = params =>
  request.post('/customer-api/customer/ai/addWatchStockNews', params)

